import '~/env'
import Vue from 'vue'
import ReferralLeakageAuditPage from '~/pages/public/ReferralLeakageAuditPage.vue'

function queryFromLocation() {
    const query = {}
    const params = new URLSearchParams(window.location.search)

    params.forEach((value, key) => {
        query[key] = value
    })

    query.embed = '1'

    return query
}

Vue.prototype.$route = {
    query: queryFromLocation(),
}

new Vue({
    render: (h) => h(ReferralLeakageAuditPage),
}).$mount('#audit-embed')
